import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import {UtilService} from "@app/modules/shared/services/util.service";
import {ConvertIsoDateService} from "@app/modules/shared/services/convert-iso-date.service";
import {TranslateService} from "@app/modules/shared/services/translate/translate.service";
import {ColumnsDto} from "@app/modules/shared/model/columns.dto";
import {KlPreferenceSaveFormComponent} from "@app/modules/shared/components/preference-form/kl-preference-save-form.component";
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {KlSweetAlertService} from "@app/modules/shared/services/message/kl-sweet-alert.service";
import {
  ExplorerService,
  TabConfig,
} from "@app/modules/shared/services/explorer.service";
import {L10n, setCulture} from "@syncfusion/ej2-base";

import * as wjSheet from "wijmo/wijmo.grid.sheet";
import * as wjCore from "wijmo/wijmo";
import {GridSettings} from "@syncfusion/ej2-pivotview/src/pivotview/model/gridsettings";
import * as wjGrid from "wijmo/wijmo.grid";
import * as wjXlsx from "wijmo/wijmo.grid.xlsx";
import * as wjPDF from "wijmo/wijmo.pdf";
import * as wjGridPDF from "wijmo/wijmo.grid.pdf";
import {findIndex} from "lodash";
import {CULTURES} from "@app/modules/shared/services/translate/cultures";
import {ApiService} from "@app/modules/shared/services/base/api.service";
import {catchError} from "rxjs/operators";
import {forkJoin, of as observableOf} from "rxjs";
import {DynamicComponent} from "@app/data/dashboard/interfaces/dynamic-component.interface";
import {CompanyDto} from "../../model/company.dto";
import {ErpIntegrationParamsDto} from "../../model/erp-integration-params.dto";
import {ReportTypeEnum} from "../../model/report-type.enum";
import {IDataOptions} from "@syncfusion/ej2-pivotview/src/base";
import {
  ToolbarItems,
  EnginePopulatedEventArgs,
} from "@syncfusion/ej2-pivotview/src/common";
import {PivotView} from "@syncfusion/ej2-pivotview/src/pivotview";
import {PivotFieldListComponent} from "@syncfusion/ej2-angular-pivotview";
import {FlexGridFilter} from "wijmo/wijmo.grid.filter";
import {KlLoadingService} from "../../services/kl-loading.service";

declare var moment;

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: "kl-report",
  templateUrl: "./kl-report.component.html",
  styleUrls: ["./kl-report.component.scss"],
})
export class KlReportComponent implements OnInit {
  @ViewChild(forwardRef(() => KlPreferenceSaveFormComponent), {static: false})
  klPreferenceSaveFormComponent: any;
  @ViewChild("templateListModal", {static: false})
  public templateListModal: any;
  @ViewChild("flexSheet", {static: false}) flexSheet: wjSheet.FlexSheet;
  @ViewChild("syncPivot", {static: false}) public pivotGrid: PivotView;
  @ViewChild("klReportFlexGrid", {static: false})
  public flexGrid: wjGrid.FlexGrid;
  @ViewChild("flexGridFilterEl") flexGridFilterEl: FlexGridFilter;

  @Input() gridHeaderName: string;
  @Input() parentModuleName: string;
  @Input() moduleName: string;
  @Input() key: string;
  @Input() type: string;
  @Input() haveAggregate: boolean;
  @Input() report_type: string;
  @Input() report_title: string;
  @Input() columns: Array<ColumnsDto>;
  @Input() filter: any;
  @Input() url: string;
  @Input() reportName: string;
  @Input() company: CompanyDto;
  @Input() pivotColumns: Array<any>;
  @Input() pivotValues: Array<any>;
  @Input() pivotRows: Array<any>;
  @Input() formatSettings: Array<any>;
  @Input() dataSourceSettings: IDataOptions;
  @Input() gridSettings: GridSettings;
  @Input() working_period_id: string;

  @Output() onError = new EventEmitter();

  // culture = this.utilService.currentLanguage().toUpperCase();
  headers: HttpHeaders;
  showFieldPanel = false;
  showTemplatePanel = false;
  showPivot = false;

  gridCollectionView: wjCore.CollectionView;

  erpParams: ErpIntegrationParamsDto;

  data: any;

  // grid properties
  currentItem: any;
  currentTemplate: any;
  currentColumnData = [];
  columnLayout = [];
  defaultColumns = [];
  layout: any;
  index = 0;
  templates = [];
  excelReportShow = false;
  showGrid = false;

  defaultPivotColumns: Array<any>;
  defaultPivotValues: Array<any>;
  defaultPivotRows: Array<any>;
  defaultFormatSettings: Array<any>;

  alertMessage: string;
  alertType: string;
  alertShow: boolean;
  showMaterialExtractButton: boolean;

  cultureScript = null;
  isTemplatesOpen: boolean;
  toolBar: any;

  pivotFields = [];

  height = 100;

  loadingText = "";
  showLoading: boolean;

  toolbarOptions: ToolbarItems[];
  currentLanguage = "tr";
  localeCulture = "tr";
  @ViewChild("pivotfieldlist", {static: false})
  public fieldlistObj: PivotFieldListComponent;

  ReportTypeEnum = ReportTypeEnum;

  afterEnginePopulate(args: EnginePopulatedEventArgs): void {
    if (this.fieldlistObj && this.pivotGrid) {
      this.fieldlistObj.update(this.pivotGrid);
    }
  }

  constructor(
    private http: HttpClient,
    private sweetAlertService: KlSweetAlertService,
    private explorerService: ExplorerService,
    private dateConvert: ConvertIsoDateService,
    private utilService: UtilService,
    private apiService: ApiService,
    private translateService: TranslateService,
    private convertIsoDateService: ConvertIsoDateService,
    private klLoadingService: KlLoadingService
  ) {
    this._formatItem = this._formatItem.bind(this);
  }

  showLoadingFunc(loadingText: string) {
    this.loadingText = loadingText;
    this.showLoading = true;
  }

  hideLoadingFunc() {
    this.klLoadingService.hide();
  }

  ngOnInit() {
    console.log("this.co >> ", this.columns);
    this.klLoadingService.show("loading");
    this.toolbarOptions = [
      "Save",
      "SaveAs",
      "Rename",
      "Remove",
      "Load",
      "Grid",
      "Chart",
      "Export",
      "SubTotal",
      "GrandTotal",
      "Formatting",
      "FieldList",
    ] as ToolbarItems[];
    this.defaultPivotColumns = this.utilService.deepCopy(this.pivotColumns);
    this.defaultPivotRows = this.utilService.deepCopy(this.pivotRows);
    this.defaultPivotValues = this.utilService.deepCopy(this.pivotValues);
    this.defaultFormatSettings = this.utilService.deepCopy(this.formatSettings);
    this.http
      .get("assets/syncfusion-pivot-locale.json")
      .subscribe((locale: any) => {
        L10n.load(locale);
        setCulture(this.currentLanguage);
      });
    this.height = window.innerHeight - 40;
    const commitObject = {
      parent: {
        module: this.parentModuleName,
      },
      module: this.moduleName,
      key: this.key,
      type: this.type,
      company_id: this.company ? this.company.id : null,
      product_type: "JRETAIL",
    };
    // const erpParamsRequest = this.apiService
    //   .getAllData("erp-integration-params")
    //   .pipe(catchError((error: any) => this.handleError(error)));
    const designRequest = this.apiService
      .getFilteredData("design", commitObject)
      .pipe(catchError((error: any) => this.handleError(error)));
    const generalParamsRequest = this.apiService
      .getAllData("general-params")
      .pipe(catchError((error: any) => this.handleError(error)));
    forkJoin([
      // erpParamsRequest,
      designRequest,
      generalParamsRequest,
    ]).subscribe(
      ([
        // erpParamsResponse,
        designResponse,
        generalParamsResponse,
      ]) => {
        // if (erpParamsResponse) {
        //   this.erpParams = erpParamsResponse;
        // }
        generalParamsResponse.forEach((data) => {
          if (data.key_num === 110) {
            wjCore.setLicenseKey(data.value);
          }
        });
        if (this.report_type === ReportTypeEnum.GRID) {
          let template: any;
          if (designResponse.data.length > 0) {
            for (let i = 0; i < designResponse.data.length; i++) {
              if (designResponse.data[i].level_default === "DEFAULT") {
                this.index = i;
                this.currentTemplate = {
                  layout: JSON.parse(designResponse.data[i].content),
                  description: designResponse.data[i].description,
                  id: designResponse.data[i].id,
                  level: designResponse.data[i].level,
                  level_values: designResponse.data[i].level_values,
                  level_default: designResponse.data[i].level_default,
                };
              }
              this.templates.push({
                layout: JSON.parse(designResponse.data[i].content),
                description: designResponse.data[i].description,
                id: designResponse.data[i].id,
                level: designResponse.data[i].level,
                level_values: designResponse.data[i].level_values,
                level_default: designResponse.data[i].level_default,
              });
            }
          }
        } else {
          if (designResponse.data.length > 0) {
            this.templates = designResponse.data;
          }
        }
        this.apiService.postWithoutData(this.url, this.filter).subscribe(
          (response) => {
            // if (response.zip_data) {
            //   this.utilService
            //     .base64ToBlob(response.zip_data, "zipFile.json")
            //     .then(
            //       (file: string) => {
            //         const parseFile = JSON.parse(file);
            //         this.renderData(parseFile.body.data.report_fields);
            //       },
            //       (message) => this.handleError(message)
            //     );
            // } else {
            this.renderData(response?.data ?? []);
            // }
          },
          (error) => this.handleError(error)
        );
      },
      (error) => this.handleError(error)
    );
  }

  reload() {
    this.klLoadingService.show("loading");
    this.apiService.postWithoutData(this.url, this.filter).subscribe(
      (response) => {
        // if (response.zip_data) {
        //   this.utilService.base64ToBlob(response.zip_data, "zipFile.json").then(
        //     (file: string) => {
        //       const parseFile = JSON.parse(file);
        //       this.renderData(parseFile.body.data.report_fields);
        //     },
        //     (message) => this.handleError(message)
        //   );
        // } else {
        //   this.renderData([]);
        // }
        this.hideLoadingFunc();
        this.renderData(response?.data ?? []);
      },
      (error) => this.handleError(error)
    );
  }

  // getMaterialTransactionExtract() {
  //   if (this.data && this.report_type === ReportTypeEnum.GRID) {
  //     const currentItem = this.gridCollectionView ? (this.gridCollectionView.currentItem ? this.gridCollectionView.currentItem : this.gridCollectionView.sourceCollection[0] ? this.gridCollectionView.sourceCollection[0] : {}) : {};
  //     if (currentItem && currentItem.material_id) {
  //       const tabConfig = <TabConfig>{
  //         id: 'material_transactions_extract_' + currentItem.material_id,
  //         title: 'material_transaction_extract',
  //         isCloseable: true,
  //         childTemplate: <DynamicComponent>{
  //           mode: 'list',
  //           modalId: 'material_transactions_extract_' + currentItem.material_id,
  //           dataContext: [],
  //           templateContext: {
  //             material: {
  //               id: currentItem.material_id,
  //               code: currentItem.material_code,
  //               description: currentItem.material_description,
  //             },
  //             erpParams: this.erpParams,
  //           },
  //           template: MaterialTransactionExtractComponent,
  //         },
  //       };
  //       this.explorerService.openTab(tabConfig);
  //     }
  //   }
  // }

  initializeGrid(flex: wjGrid.FlexGrid) {
    if (this.haveAggregate) {
      flex.columnFooters.rows.push(new wjGrid.GroupRow());
      flex.bottomLeftCells.setCellData(0, 0, "Σ");
    }
  }

  renderData(data) {
    this.data = data ? data : [];
    if (this.report_type === ReportTypeEnum.EXCEL_SHEET) {
      this.excelReportShow = true;
    }
    if (this.report_type === ReportTypeEnum.PIVOT) {
      this.showPivot = true;
      this.columns.forEach((column) => {
        this.pivotFields.push({
          name: column.binding,
          caption: this.translateService.instant(column.header),
        });
      });
      this.dataSourceSettings = {
        enableSorting: true,
        columns: this.pivotColumns ? this.pivotColumns : [],
        values: this.pivotValues ? this.pivotValues : [],
        dataSource: data,
        rows: this.pivotRows ? this.pivotRows : [],
        formatSettings: this.formatSettings ? this.formatSettings : [],
        expandAll: false,
        filters: [],
        fieldMapping: this.pivotFields,
      };
    }
    if (this.report_type === ReportTypeEnum.GRID) {
      this.showMaterialExtractButton = data[0]
        ? Object.keys(data[0]).findIndex((key) => key === "material_id") !== -1
        : false;
      this.gridCollectionView = new wjCore.CollectionView<any>(this.data);
      if (!this.showGrid) {
        this.showGrid = true;
        setTimeout(() => {
          if (this.currentTemplate) {
            this.selectLayout(this.currentTemplate, this.index);
          }
        }, 10);
      }
    }
    this.defaultColumns = this.utilService.deepCopy(this.columns);
    this.hideLoadingFunc();
  }

  saveReport(args: any) {
    if (args.reportName !== "Sample Report") {
      if (args.reportName !== "Varsayılan rapor") {
        const commitObject = {
          // parent: {
          //   module: this.parentModuleName,
          // },
          // level_values: [],
          // level: "USER_ALL",
          // level_default: "NO_DEFAULT",
          // product_type: "JRETAIL",
          // description: args.reportName,
          // module: this.moduleName,
          // key: this.key,
          // type: this.type,
          // company_id: this.company ? this.company.id : null,
          content: args.report,
        };
        this.apiService.addData("design", commitObject).subscribe(
          (response) => {
            this.templates.push(response);
            this.pivotGrid.dataSourceSettings = JSON.parse(
              response.content
            ).dataSourceSettings;
            this.klPreferenceSaveFormComponent.hide();
            this.updateReport();
          },
          (error) => this.handleError(error)
        );
      }
    }
  }

  fetchReport(args: any) {
    let reportList: string[] = [];
    this.templates.map((item: any) => {
      reportList.push(item.description);
    });
    args.reportName = reportList;
  }

  updateReport() {
    let reportList: string[] = [];
    this.templates.map((item: any) => {
      reportList.push(item.description);
    });
    // Here you can refresh the report list by feeding updated datsource fetched from your DB.
    const reportListObj = (
      document.querySelector(
        "#" + this.pivotGrid.element.id + "_reportlist"
      ) as any
    ).ej2_instances;
    if (reportListObj) {
      reportListObj[0].dataSource = reportList;
      reportListObj[0].value = (
        this.pivotGrid.toolbarModule as any
      ).currentReport;
    }
  }

  loadReport(args: any) {
    this.templates.map((item: any) => {
      if (args.reportName === item.description) {
        args.report = item.content;
      }
    });
    if (args.report) {
      this.pivotGrid.dataSourceSettings = JSON.parse(
        args.report
      ).dataSourceSettings;
    }
  }

  removeReport(args: any) {
    let currenItem: any;
    let currentIndex = -1;
    this.templates.map((item: any, index) => {
      if (args.reportName === item.description) {
        currenItem = item;
        currentIndex = index;
      }
    });

    if (currenItem) {
      this.apiService.deleteData("design", currenItem.id).subscribe(
        () => {
          if (currentIndex != -1) {
            this.templates.splice(currentIndex, 1);
            this.updateReport();
          }
        },
        (errDeletePreference) => this.handleError(errDeletePreference)
      );
    }
  }

  renameReport(args: any) {
    let reportCollection: string[] = [];
    reportCollection.map(function (item: any): any {
      if (args.reportName === item.reportName) {
        item.reportName = args.rename;
      }
    });
  }

  templateOpen() {
    this.showTemplatePanel = true;
    this.showFieldPanel = false;
  }

  filedsOpen() {
    this.showFieldPanel = true;
    this.showTemplatePanel = false;
  }

  deleteLayout(template, index) {
    this.sweetAlertService.alert(
      {
        title: "warning",
        text: "entry_must_be_delete",
        customClass: "kl-alert",
        showCloseButton: false,
      },
      () => {
        this.apiService.deleteData("design", template.id).subscribe(
          () => {
            this.templates.splice(index, 1);
            this.setDefaultTemplate();
          },
          (errPreference) => {
            this.alertMessage =
              this.utilService.alertErrorMessage(errPreference);
            this.alertType = "error";
            this.alertShow = true;
          }
        );
      },
      () => {}
    );
  }

  setDefaultTemplate() {
    this.currentTemplate = null;
    if (this.report_type === ReportTypeEnum.PIVOT) {
      this.pivotGrid.dataSourceSettings.filters = [];
      this.pivotGrid.dataSourceSettings.columns = this.pivotColumns
        ? this.utilService.deepCopy(this.defaultPivotColumns)
        : [];
      this.pivotGrid.dataSourceSettings.values = this.pivotValues
        ? this.utilService.deepCopy(this.defaultPivotValues)
        : [];
      this.pivotGrid.dataSourceSettings.formatSettings = this.formatSettings
        ? this.utilService.deepCopy(this.defaultFormatSettings)
        : [];
    }
    if (this.report_type === ReportTypeEnum.GRID) {
      this.columns = this.utilService.deepCopy(this.defaultColumns);
      this.flexGrid.refresh(true);
    }
  }

  selectLayout(template, index) {
    this.currentTemplate = template;
    this.index = index;
    if (this.report_type === ReportTypeEnum.PIVOT) {
      this.pivotGrid.dataSourceSettings.filters = template.layout.filters;
      this.pivotGrid.dataSourceSettings.columns = template.layout.columns;
      this.pivotGrid.dataSourceSettings.values = template.layout.values;
      this.pivotGrid.dataSourceSettings.formatSettings =
        template.layout.formatSettings;
    }
    if (this.report_type === ReportTypeEnum.GRID) {
      this.currentColumnData = [];
      template.layout.columns.forEach((column) => {
        for (let i = 0; i < this.defaultColumns.length; i++) {
          if (column.binding === this.defaultColumns[i].binding) {
            let obj: any = {};
            const defaultColumns = this.utilService.deepCopy(
              this.defaultColumns[i]
            );
            if (
              this.translateService.instant(this.defaultColumns[i].header) !==
              column.header
            ) {
              obj = Object.assign(defaultColumns, {
                visible: column.visible,
                header: column.header,
                width: column.width ? column.width : defaultColumns.width,
              });
            } else {
              obj = Object.assign(defaultColumns, {
                visible: column.visible,
                width: column.width ? column.width : defaultColumns.width,
              });
            }
            this.currentColumnData.push(obj);
          }
        }
      });
      this.flexGrid.columns.frozen = template.layout.frozen
        ? template.layout.frozen
        : 0;
      this.columns = [];
      this.columns = this.utilService.deepCopy(this.currentColumnData);
      this.columns.forEach((column, columnIndex) => {
        this.flexGrid.columns[columnIndex].visible = !column.visible;
      });
      // let j = 0;
      // this.currentColumnData = [];
      // template.layout.columns.forEach(column => {
      //   for (let i = 0; i < this.columns.length; i++) {
      //     if (column.binding === this.columns[i].binding) {
      //       this.currentColumnData[j] = this.columns[i];
      //       Object.assign(this.currentColumnData[j], {visible: column.visible});
      //     }
      //   }
      //   j++;
      // });
      // this.columns = [];
      // this.columns = this.utilService.deepCopy(this.currentColumnData);
      this.flexGrid.refresh(true);
    }
  }

  saveLayout(mode, currentTemplate?, index?) {
    this.index = index;
    this.klPreferenceSaveFormComponent.show(mode, "design", currentTemplate);
  }

  showTemplateActionButton(template): boolean {
    const userRole = this.utilService.userRole;
    let show = false;
    show = userRole === "ROLE_ADMIN";
    // if (!show) {
    //   show = template.level === 'USER' && template.level_values.findIndex((value) => value === this.utilService.userInfo.id.toString()) !== -1;
    // }
    // return show;
    return true;
  }

  commitSave(event: any) {
    let content: any;
    this.columnLayout = [];
    for (let i = 0; i < this.flexGrid.columns.length; i++) {
      for (let j = 0; j < this.defaultColumns.length; j++) {
        if (
          this.flexGrid.columns[i].binding === this.defaultColumns[j].binding
        ) {
          let obj;
          const defaultColumns = this.utilService.deepCopy(
            this.defaultColumns[j]
          );
          if (
            this.translateService.instant(this.defaultColumns[j].header) !==
            this.flexGrid.columns[i].header
          ) {
            obj = Object.assign(defaultColumns, {
              visible: this.flexGrid.columns[i].visible,
              header: this.flexGrid.columns[i].header,
            });
          } else {
            obj = Object.assign(defaultColumns, {
              visible: this.flexGrid.columns[i].visible,
            });
          }
          if (this.defaultColumns[j].width === this.flexGrid.columns[i].width) {
            delete obj.width;
          } else {
            obj.width = this.flexGrid.columns[i].width;
          }
          this.columnLayout.push(obj);
        }
      }
    }
    // for (let i = 0; i < this.flexGrid.columns.length; i++) {
    //   for (let j = 0; j < this.defaultColumns.length; j++) {
    //     if (this.flexGrid.columns[i].binding === this.defaultColumns[j].binding) {
    //       const obj = Object.assign(this.defaultColumns[j], {visible: this.flexGrid.columns[i].visible});
    //       this.columnLayout.push(obj);
    //     }
    //   }
    // }
    this.columns = this.utilService.deepCopy(this.columnLayout);
    content = JSON.stringify({columns: this.columns});
    const commitObject = {
      // parent: {
      //   module: this.parentModuleName,
      // },
      // product_type: "JRETAIL",
      // level: event.level,
      // level_values: event.levelValues,
      // level_default: event.levelDesign ? "DEFAULT" : "NO_DEFAULT",
      // description: event.entryName,
      // module: this.moduleName,
      // key: this.key,
      // type: this.type,
      content: content,
      // company_id: this.company ? this.company.id : null,
    };
    switch (event.commitType) {
      case "add":
        this.apiService.addData("design", commitObject).subscribe(
          (resPreference: any) => {
            this.currentTemplate = {
              layout: JSON.parse(resPreference.content),
              description: resPreference.description,
              id: resPreference.id,
              level: resPreference.level,
              level_values: resPreference.level_values,
              level_default: resPreference.level_default,
            };
            this.templates.push({
              layout: JSON.parse(resPreference.content),
              description: resPreference.description,
              id: resPreference.id,
              level: resPreference.level,
              level_values: resPreference.level_values,
              level_default: resPreference.level_default,
            });
            this.selectLayout(this.currentTemplate, this.templates.length - 1);
            this.klPreferenceSaveFormComponent.hide();
          },
          (errPreference) => {
            this.alertMessage =
              this.utilService.alertErrorMessage(errPreference);
            this.alertType = "error";
            this.alertShow = true;
          }
        );
        break;
      case "edit":
        commitObject["id"] = event.id;
        this.apiService.updateData("design", commitObject).subscribe(
          (resPreference: any) => {
            if (resPreference) {
              this.currentTemplate = {
                layout: JSON.parse(resPreference.content),
                description: resPreference.description,
                id: resPreference.id,
                level: resPreference.level,
                level_values: resPreference.level_values,
                level_default: resPreference.level_default,
              };
              this.templates[this.index].description =
                resPreference.description;
              this.templates[this.index].layout = JSON.parse(
                resPreference.content
              );
              this.templates[this.index].id = resPreference.id;
              this.templates[this.index].level = resPreference.level;
              this.templates[this.index].level_default =
                resPreference.level_default;
              this.templates[this.index].level_values =
                resPreference.level_values;
              this.selectLayout(this.currentTemplate, this.index);
              this.klPreferenceSaveFormComponent.hide();
            }
          },
          (errPreference) => {
            this.alertMessage =
              this.utilService.alertErrorMessage(errPreference);
            this.alertType = "error";
            this.alertShow = true;
          }
        );
        break;
    }
  }

  export(type) {
    if (type === "XLSX") {
      if (this.report_type === ReportTypeEnum.GRID) {
        this.showLoading = true;
        wjXlsx.FlexGridXlsxConverter.saveAsync(
          this.flexGrid,
          {
            includeColumnHeaders: true,
            includeCellStyles: true,
            formatItem: this._formatItem,
          },
          this.dateConvert.convertDate(new Date()) +
            "-" +
            this.translateService.instant(this.moduleName) +
            ".xlsx",
          null,
          null,
          (progress) => {
            this.loadingText = `${progress}%`;
            if (progress === 100) {
              this.showLoading = false;
              this.loadingText = "";
            }
          },
          true
        );
      }

      if (this.report_type === ReportTypeEnum.PIVOT) {
        this.pivotGrid.excelExport();
      }
    }
    if (type === "PDF") {
      if (this.report_type === ReportTypeEnum.GRID) {
        const doc = new wjPDF.PdfDocument({
          ended: (sender, args) => {
            wjPDF.saveBlob(
              args.blob,
              this.dateConvert.convertDate(new Date()) +
                "-" +
                this.report_type +
                ".pdf"
            );
          },
        });
        doc.drawText("", 0, 30);
        wjGridPDF.FlexGridPdfConverter.drawToPosition(
          this.flexGrid,
          doc,
          new wjCore.Point(0, 40),
          null,
          null,
          {
            maxPages: 10,
            styles: {
              cellStyle: {
                backgroundColor: "#ffffff",
                borderColor: "#c6c6c6",
              },
              headerCellStyle: {
                backgroundColor: "#eaeaea",
              },
            },
          }
        );
        doc.end();
      }

      if (this.report_type === ReportTypeEnum.PIVOT) {
        this.pivotGrid.pdfExport();
      }
    }
  }

  _formatItem(args) {
    const columnIndex = findIndex(this.columns, {
      binding: this.flexGrid.columns[args.col].binding,
    });
    if (columnIndex !== -1) {
      const column = this.columns[columnIndex];
      if (column.translate) {
        args.xlsxCell.value = this.translateService.instant(
          args.xlsxCell.value
        );
      }

      if (column.date) {
        if (typeof args.xlsxCell.value === "number") {
          const formatString = "DD.MM.YYYY";
          args.xlsxCell.value = moment(new Date(args.xlsxCell.value)).format(
            formatString
          );
        }
      }
    }
  }

  onPrint() {
    if (this.report_type === ReportTypeEnum.GRID && this.gridCollectionView) {
      // create PrintDocument
      let doc = new wjCore.PrintDocument({
        title: this.report_title,
        copyCss: false, // prevent cross-origin issues in jsfiddle
      });
      // add CSS explicitly (since we can't use copyCss in jsfiddle)
      doc.append(
        '<link href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css" rel="stylesheet">'
      );
      doc.append(
        '<link href="https://cdn.grapecity.com/wijmo/5.latest/styles/wijmo.min.css" rel="stylesheet">'
      );
      // add some simple text
      doc.append("<h1>" + this.report_title + "</h1>");
      let tbl = this._renderTable(this.flexGrid);
      doc.append(tbl);
      // print the document
      doc.print();
    }
  }

  // renders grid as a table
  private _renderTable(flex: wjGrid.FlexGrid) {
    // start table
    let tbl = "<table>";
    // headers
    if (flex.headersVisibility && wjGrid.HeadersVisibility.Column) {
      tbl += "<thead>";
      for (let r = 0; r < flex.columnHeaders.rows.length; r++) {
        tbl += this._renderRow(flex.columnHeaders, r);
      }
      tbl += "</thead>";
    }
    // body
    tbl += "<tbody>";
    for (let r = 0; r < flex.rows.length; r++) {
      tbl += this._renderRow(flex.cells, r, r === flex.rows.length - 1);
    }
    tbl += "</tbody>";
    // done
    tbl += "</table>";
    return tbl;
  }

  private _renderRow(panel: wjGrid.GridPanel, r: number, end = false) {
    let tr = "",
      row = panel.rows[r];
    if (row.renderSize > 0) {
      tr += "<tr>";
      for (let c = 0; c < panel.columns.length; c++) {
        let col = panel.columns[c];
        if (col.renderSize > 0) {
          // get cell style, content
          let style =
            "width:" +
            col.renderSize +
            "px; text-align: left; padding-right: 6px; border: 0.5px solid #30384945";
          let content: any = panel.getCellData(r, c, true);
          if (!row.isContentHtml && !col.isContentHtml) {
            content = wjCore.escapeHtml(content);
          }
          // add cell to row
          if (panel.cellType == wjGrid.CellType.ColumnHeader) {
            tr += '<th style="' + style + '">' + content + "</th>";
          } else {
            // show boolean values as checkboxes
            let raw = panel.getCellData(r, c, false);
            if (raw === true) {
              content = "&#9745;";
            } else if (raw === false) {
              content = "&#9744;";
            }
            if (typeof raw === "number" && raw.toString().length === 13) {
              content = this.dateConvert.makeDate(new Date(raw), "DD.MM.YYYY");
            }
            tr += '<td style="' + style + '">' + content + "</td>";
          }
        }
      }
      tr += "</tr>";
      if (end) {
        tr += "<tr>";
        for (let c = 0; c < panel.columns.length; c++) {
          let col = panel.columns[c];
          if (col.renderSize > 0) {
            let aggregate;
            if (col.aggregate) {
              aggregate = wjCore.getAggregate(
                col.aggregate,
                panel.grid.collectionView.items,
                col.binding
              );
              aggregate = wjCore.Globalize.format(aggregate, col.format);
            } else {
              aggregate = "";
            }
            let style =
              "width:" +
              col.renderSize +
              "px; font-weight: 600; text-align: left; padding-right: 6px; border: 0.5px solid #30384945";
            tr += '<td style="' + style + '">' + aggregate + "</td>";
          }
        }
        tr += "</tr>";
      }
    }
    return tr;
  }

  editingFilter(flexGridFilter, event: wjGrid.CellRangeEventArgs) {
    flexGridFilter.getColumnFilter(event.col).valueFilter.maxValues = 100000;
    if (this.columns[event.col].format) {
      if (this.columns[event.col].format.includes("date")) {
        flexGridFilter.getColumnFilter(event.col).dataMap = new wjGrid.DataMap(
          this.gridCollectionView.sourceCollection
            .filter((line) => line[this.columns[event.col].binding])
            .map((line) => {
              if (line[this.columns[event.col].binding]) {
                return {
                  value: line[this.columns[event.col].binding],
                  caption:
                    this.columns[event.col].format === "date"
                      ? this.convertIsoDateService.makeDate(
                          new Date(line[this.columns[event.col].binding]),
                          this.utilService.dateFormatString
                        )
                      : this.convertIsoDateService.convertDateAndTime(
                          new Date(line[this.columns[event.col].binding]),
                          this.utilService.dateFormatString
                        ),
                };
              }
            }),
          "value",
          "caption"
        );
      }
    } else if (this.columns[event.col].translate) {
      const dataMap = new wjGrid.DataMap(
        this.gridCollectionView.sourceCollection.map((line) => {
          return {
            value: line[this.columns[event.col].binding],
            caption: this.translateService.instant(
              line[this.columns[event.col].binding]
            ),
          };
        }),
        "value",
        "caption"
      );
      flexGridFilter.getColumnFilter(event.col).dataMap = dataMap;
    }
  }

  onFilterChanged() {
    const filterState = this.flexGridFilterEl.filterDefinition;
    const filterObj = JSON.parse(filterState);
    if (filterObj?.filters.length > 0) {
      for (let filter of filterObj.filters) {
        filter.showValues = Object.keys(filter.showValues).reduce(
          (acc, key) => {
            const newKey = this.translateService.backInstant(key);
            if (newKey) {
              acc[newKey] = filter.showValues[key];
            }
            return acc;
          },
          {}
        );
      }
    }

    localStorage.setItem("myFilterState", JSON.stringify(filterObj));
  }

  getValue(item, binding) {
    if (binding.includes(".")) {
      const explodeBinding = binding.split(".");
      if (item[explodeBinding[0]]) {
        return item[explodeBinding[0]][explodeBinding[1]];
      } else {
        return "";
      }
    } else {
      return item[binding];
    }
  }

  handleError(error) {
    this.hideLoadingFunc();
    this.onError.emit(this.utilService.alertErrorMessage(error));
    return observableOf(null);
  }
}
